import type { PhotoInfo } from "@/types/photoApiDef"
import type { ConstructionAccountInfo } from "@/types/constructionApiDef"
import moment from 'moment'

const getS3Key = (photo: PhotoInfo, imageName: string)=> {
  return `${photo.s3path}${imageName}${photo.extension}`
}

// 表示するimageの長辺ピクセル数を指定し、参照するサムネイル画像のs3Keyを取得する
export const getPhotoThumbnailS3Key = (photo: PhotoInfo, longSideSize: number) => {
  // 長辺サイズは160以下の場合
  if(longSideSize <= 160) return getS3Key(photo, 'thumbnail_s')

  // 長辺サイズは240以下の場合
  if(longSideSize <= 240) return getS3Key(photo, 'thumbnail_m')

  // 長辺サイズは600以下の場合
  if(longSideSize <= 600) return getS3Key(photo, 'thumbnail_l')

  // 上記以外
  return getS3Key(photo, 'thumbnail_xl')
}

// ダウンロード用画像のs3Keyを取得する
export const getDownLoadPhotoS3Key = (photo: PhotoInfo) => {
  return getS3Key(photo, 'original')
}
// 編集用画像のs3Keyを取得する
export const getEditPhotoS3Key = (photo: PhotoInfo) => {
  return getS3Key(photo, 'original')
}

// 写真へのアクセス権があるか？
export const isPhotoAccessPermissions = (photo: PhotoInfo, constructionAccountInfo: ConstructionAccountInfo) => {
  // 管理者
  if(constructionAccountInfo.role_type === 'manager') return true
  // 一般でも見れるアカウント（作成直後には、shared_account_ids := [ 作成者 ] となる）
  if (photo.shared_account_ids && 
      photo.shared_account_ids.indexOf(constructionAccountInfo.account_id) !== -1) return true
  return false
}

// 写真一覧に表示される
export const isDisplayOnPhotoList = (photo: PhotoInfo) => {
  if(photo.hidden_at) return false
  if(photo.deleted_at) return false
  return true
}
// 写真削除済み一覧に表示する
export const isDisplayOnDeletedList = (photo: PhotoInfo) => {
  if(photo.hidden_at) return false
  if(!photo.deleted_at) return false

  // 現在時刻を取得
  const currentMillis = moment().valueOf();
  const limitTime = moment(currentMillis)
  limitTime.add(-30, 'days')
  if(limitTime.valueOf() < photo.deleted_at) return true

  return false
}

// 電子マーカー切り替えチェックボックスを有効化する
export const isEnableToggleMarkerCheckBox = (photo: PhotoInfo) => {
  return (photo.extension.toLowerCase() === '.svg'); 
}

// 写真情報（詳細ダイアログ）で、撮影者を不明で表示する
export const isDispUnknownPhotographer = (photo: PhotoInfo) => {
  if(!photo.shooting_account_id) return true
  return false; 
}

// 写真情報（詳細ダイアログ）で、経度・緯度を表示する
export const isDispGeoCoord = (photo: PhotoInfo) => {
  if(photo.kind && photo.kind.zumen_capture) return false
  return true
}

// 写真情報（詳細ダイアログ）で、基本的な項目のみ表示する
export const isBasicDetailLayout = (photo: PhotoInfo) => {
  return (!photo.kokuban_hash)
}

// 図面キャプチャーの写真
export const isZumenCapture = (photoInfo: PhotoInfo) => {
  return ('zumen_capture' in photoInfo.kind)
}
// アップロードした写真
export const isWebUpload = (photoInfo: PhotoInfo) => {
  return (photoInfo.register_route === 'web_upload')
}
// 編集、削除不可の検索ワードを判定する
export const disabledSearchWord = (photoInfo: PhotoInfo, searchWord: string) => {
  // 図面キャプチャーの写真
  if (isZumenCapture(photoInfo)) {
    return ['キャプチャー'].includes(searchWord)
  }
  // アップロードした写真
  if (isWebUpload(photoInfo)) {
    return ['工事写真情報なし'].includes(searchWord)
  }
  return false
}